import React, { Component } from "react";
import { IImage } from "../../../models/Image";
import StorageGallery, { StorageGalleryPropsBase } from "./StorageGallery";
import UIModal from "../../../components/ui/UIModal";
import { UIButtonWithLoadingProgress } from "../../../components/ui/UIComponents";
import { withUploadContext, UploadContextProps } from "../../contexts/upload/UploadContext";
import { MediaAccepted, UploadMode } from "../../../laco-common/base/models/upload";

type StorageGalleryPickerProps = StorageGalleryPropsBase & {
	open: boolean;
	onCancel: () => any;
	onImagesSelected: (images: IImage[]) => any;
} & UploadContextProps;

type StorageGalleryPickerState = {
	selected: IImage[];
};

class StorageGalleryPicker extends Component<StorageGalleryPickerProps, StorageGalleryPickerState> {
	private readonly mediaAccepted: MediaAccepted = this.props.uploadContext.mediaAccepted || MediaAccepted.IMAGE;

	state = {
		selected: this.props.selectedImages || [],
	};

	onImageClicked(image: IImage, i: number) {
		const foundIndex: number = this.state.selected.findIndex(
			(img: IImage) =>
				img.filename === image.filename ||
				(img.docId && image.docId && img.docId === image.docId) ||
				img.url === image.url
		);
		const isSingleSelect: boolean =
			this.props.uploadContext.mode === UploadMode.SINGLE || this.props.uploadContext.maxFileCount === 1;
		if (isSingleSelect) {
			if (foundIndex >= 0) {
				this.setState({ selected: [] });
			} else {
				this.setState({ selected: [image] });
			}
			return;
		}
		if (foundIndex >= 0) {
			//deselect
			const removedArr = [];
			this.state.selected.forEach((item: IImage, i: number) => {
				if (i !== foundIndex) removedArr.push(item);
			});
			this.setState({ selected: removedArr });
		} else {
			this.setState({ selected: [...this.state.selected, image] });
		}
	}

	render() {
		if (!this.props.open) return null;
		const title: string = `Select ${this.mediaAccepted}`;
		const path: string = this.props.path || this.props.uploadContext?.path;
		return (
			<UIModal
				title={
					<span className="d-flex justify-content-between mr-1">
						<span className="text-capitalize">{title}</span>
						<span className="text-gray text-xxs pr-2">{path}</span>
					</span>
				}
				titleClassName="title-with-border no-capitalize flex-grow-1 ml-1"
				regTitle={true}
				pageTitle={title}
				open={this.props.open}
				onClose={() => this.props.onCancel()}
				showCloseIcon={true}
				style={{ minHeight: "40vh" }} // maxWidth: "945px",
				className="light-mode1 container-fluid"
				noContainer={true}
			>
				<div style={{ maxHeight: "70vh", overflow: "auto" }}>
					<StorageGallery
						path={path}
						useFirewire={this.props.useFirewire}
						onImageClicked={this.onImageClicked.bind(this)}
						recursive={this.props.recursive}
						showFolders={this.props.showFolders}
						selectedImages={this.state.selected}
					/>
				</div>
				<div className="d-flex justify-content-end mt-3 pr-2">
					<button
						onClick={(e) => {
							e.preventDefault();
							this.props.onCancel();
						}}
						className="btn btn-link btn-narrow mr-3"
					>
						Cancel
					</button>
					<UIButtonWithLoadingProgress
						actionName={"Updating..."}
						onClick={(e) => {
							this.props.onImagesSelected(this.state.selected);
							return Promise.resolve();
						}}
						// disabled={confirming}
						disabled={!this.state.selected?.length}
						autoFocus
						className="btn btn-primary"
						// autoFocus
					>
						Select{" "}
						{this.props.uploadContext.mode === UploadMode.SINGLE ||
						this.props.uploadContext.maxFileCount === 1
							? "File"
							: `${this.state.selected?.length ? `${this.state.selected?.length} ` : ""}Files`}
					</UIButtonWithLoadingProgress>
				</div>
			</UIModal>
		);
	}
}

export default withUploadContext<StorageGalleryPickerProps>(StorageGalleryPicker);
